export const hasMultiple = ({
  data,
  newItem,
  validator,
  persistentIdentifier,
  nonPersistentIdentifier = "id",
}) => {
  const sameTypeData = data.filter(validator);

  if (sameTypeData.length > 1) {
    return true;
  }

  if (sameTypeData.length > 0) {
    const oldRecord = sameTypeData[0];
    if (!newItem[persistentIdentifier] && !newItem[nonPersistentIdentifier]) {
      // New record with that violates unique constraints.
      return true;
    } else {
      if (
        (newItem[persistentIdentifier] &&
          oldRecord[persistentIdentifier] !== newItem[persistentIdentifier]) ||
        (newItem[nonPersistentIdentifier] &&
          oldRecord[nonPersistentIdentifier] !==
            newItem[nonPersistentIdentifier])
      ) {
        // Update a record in a way that clashes with another record.
        return true;
      }
    }
  }
  // Valid.
  return false;
};
